export enum TOASTER_TYPE {
  PRIMARY = 'primary',
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  INFO = 'info',
}

export class ToasterModel {
  id?: string;
  title?: string;
  content!: string;
  type: TOASTER_TYPE = TOASTER_TYPE.PRIMARY;
  preventClose?: boolean = false;
  timeToClose?: number = 5000;
}
